/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Line Graph Type Echart:
 *   * SOLID : solid
 *   * DASHED : dashed
 *   * DOTTED: dotted
 */
export enum LineGraphType {
  SOLID = 'SOLID',
  DASHED = 'DASHED',
  DOTTED = 'DOTTED'
}
